"use client";

import type { OnChangeValue, Options } from "react-select";
import Select from "react-select";
import dropdownStyles from "./dropdown.module.css";

export type DropdownOption = {
	value: string;
	label: string;
};

const selectStyle = () => {
	return {
		option: (provided: any, state: any) => ({
			...provided,
			backgroundColor: "#FFF",
			color: state.isSelected ? "#292929" : "#676767",
			fontSize: "0.875rem",
		}),
		valueContainer: (provided: any) => ({
			...provided,
			padding: "0 20px",
		}),
		singleValue: (provided: any) => ({
			...provided,
			backgroundColor: "#FFF",
			color: "#292929",
			padding: "0px",
		}),
		control: (provided: any) => ({
			...provided,

			backgroundColor: "#FFF",
			borderRadius: "100px",
			border: "1px solid rgba(14, 14, 14, 0.05)",
			padding: "11px 5px",
			fontSize: "0.875rem",
			fontFamily: "var(--font-goodsans)",
			fontWeight: 400,
			color: "#292929",
			":hover": {
				boxShadow: "none",
				borderColor: "rgba(14, 14, 14, 0.1)",
			},
		}),
	};
};

interface DropdownProps {
	options: Options<DropdownOption>;
	onChange: (newValue: OnChangeValue<DropdownOption, false>) => void;
	value: string;
}
export const Dropdown = ({ options, onChange, value }: DropdownProps) => {
	const styles = selectStyle();

	const currentValue = options.find((option) => option.value === value) || options[0];

	return (
		<Select
			classNames={{
				container: () => dropdownStyles.container,
			}}
			options={options}
			onChange={onChange}
			styles={styles}
			value={currentValue}
		/>
	);
};
